import Rutas from "./Rutas/Rutas";


function App() {
  return (
    <>
      <Rutas />
    </>
  );
}

export default App;
